import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { IoIosArrowDown } from 'react-icons/io';
import { HiMenuAlt3, HiX } from 'react-icons/hi';

const PageHeader = ({ onMenuToggle }) => {
    const [shopDropdown, setShopDropdown] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    // Function to toggle the mobile menu's open/close state
    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
        setShopDropdown(false);
        if (onMenuToggle) onMenuToggle(!isMenuOpen); // Notify parent (Index.jsx)
    };

    // Function to toggle shop dropdown visibility for mobile
    const toggleShopDropdown = (e) => {
        e.preventDefault();
        setShopDropdown(!shopDropdown);
    };

    // Notify parent if menu is closed by other means
    useEffect(() => {
        if (onMenuToggle) onMenuToggle(isMenuOpen);
    }, [isMenuOpen, onMenuToggle]);

    // Listen for scroll to change header background
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 10) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // Define the background style with the receding lines pattern
    const headerStyle = {
        zIndex: 40,
        // Layer the gradients. The solid/transparent color goes on top.
        // This creates a pattern of thin, angled lines for a textural effect.
        // backgroundImage: `
        //     repeating-linear-gradient(45deg, #f7f7f7, #f7f7f7 2px, transparent 2px, transparent 10px),
        //     repeating-linear-gradient(-45deg, #f7f7f7, #f7f7f7 2px, transparent 2px, transparent 10px),
        //     linear-gradient(white, white)
        // `,
        backgroundSize: 'auto, auto, cover',
        backgroundPosition: 'center',
        transition: 'background-color 0.3s, box-shadow 0.2s',
        boxShadow: scrolled ? '0 2px 16px 0 rgba(0,0,0,0.2)' : 'none'
    };

    return (
        <div
            className={`Header font-nanum-myeongjo text-gray-600 bg-white fixed top-0 left-0 right-0`}
            // className={`Header font-nanum-myeongjo text-gray-600 bg-white fixed top-0 left-0 right-0`}
            style={headerStyle}
        >
            <div className='headerContainer w-full h-16 px-4 md:px-10 lg:px-40 mx-auto flex flex-row items-center justify-start md:justify-between relative'>
                {/* Mobile specific layout for hamburger and title */}
                <div className='flex items-center justify-between w-full md:hidden'>
                    <div className='headerTitle'>
                        <a href='/'>
                            <img src="../assets/VRIFY_Africa_full_logo[1].png" alt="vrify ghana Logo" className='h-20 w-20 object-cover pt-2' />
                        </a>
                    </div>
                    <div className='z-40'>
                        <button onClick={toggleMenu} className='text-2xl focus:outline-none text-gray-700'>
                            {isMenuOpen ? (
                                <HiX className='transition-transform duration-300 transform rotate-90' />
                            ) : (
                                <HiMenuAlt3 className='transition-transform duration-300' />
                            )}
                        </button>
                    </div>
                </div>
                {/* Desktop headerTitle - hidden on mobile */}
                <div className='headerTitle hidden md:block'>
                    <Link to={'/'} className='flex flex-row gap-1 items-end'>
                        <img src="../assets/VRIFY_Africa_full_logo[1].png" alt="Pb Hotel Logo" className='h-24 w-24 object-cover' />
                        {/* <p className='capitalize text-base cursor-pointer whitespace-nowrap'>VRify technologies</p> */}
                    </Link>
                </div>

                {/* Desktop headerTabs - hidden on mobile, centered */}
                <div className='headerTabs hidden md:block absolute left-1/2 -translate-x-1/2'>
                    <ul className='flex flex-row gap-5 items-center'>
                        {/* <li className='relative capitalize text-sm font-light tracking-tight hover:text-green-700 after:content-[""] after:absolute after:left-1/2 after:-translate-x-1/2 after:bottom-[-5px] after:h-[2px] after:w-0 after:bg-green-600 after:transition-all after:duration-300 hover:after:w-full'><a href='/' rel='noreferrer'>Home</a></li> */}
                        <li
                            onMouseEnter={() => setShopDropdown(true)}
                            onMouseLeave={() => setShopDropdown(false)} 
                            className='relative capitalize text-sm font-light tracking-tight hover:text-green-700 after:content-[""] after:absolute after:left-1/2 after:-translate-x-1/2 after:bottom-[-5px] after:h-[2px] after:w-0 after:bg-green-600 after:transition-all after:duration-300 hover:after:w-full'
                        >
                            <p className='flex items-center gap-1 cursor-pointer'>
                                <span>Experience Africa</span>
                                <IoIosArrowDown className={`${shopDropdown ? 'rotate-180' : ''} transition-transform duration-200`} />
                            </p>
                            <div className={`absolute top-full left-1/2 -translate-x-1/2 mt-2 transition-all duration-300 ${shopDropdown ? 'opacity-100 visible' : 'opacity-0 invisible'}`}>
                                <ul className='bg-gray-200/90 backdrop-blur-sm shadow-2xl rounded-lg p-2 w-64 z-20 text-gray-800 font-normal'>
                                    <a href={'/cultural-festivals'} rel='noreferrer'>
                                        <li className='p-2 rounded-md capitalize transition-colors duration-200 hover:bg-green-600 hover:text-white'>
                                            Cultural Festivals
                                        </li>
                                    </a>
                                    <a href={'/historical-tours'} rel='noreferrer'>
                                        <li className='p-2 rounded-md capitalize transition-colors duration-200 hover:bg-green-600 hover:text-white'>
                                            Historical Tours
                                        </li>
                                    </a>
                                    <div
                                        className='relative group'
                                        tabIndex={0}
                                    // onMouseEnter={e => {
                                    //     e.stopPropagation();
                                    //     setShopDropdown(true);
                                    // }}
                                    // onClick={e => {
                                    //     e.stopPropagation();
                                    //     setShopDropdown(true);
                                    // }}
                                    >
                                        <a href={'/wildlife-safaris'} rel='noreferrer'>
                                            <li className='p-2 rounded-md capitalize transition-colors duration-200 hover:bg-green-600 hover:text-white cursor-pointer'>
                                                Wildlife Safaris
                                            </li>
                                        </a>
                                        {/* Mega menu for other services */}
                                        {/* <div className="absolute left-full top-0 ml-0 w-64 bg-white border-t-4 border-green-500 shadow-lg rounded-md p-4 z-30 hidden group-hover:block group-focus:block">
                                            <ul className="flex flex-col text-black">
                                                <Link to={"/other-services"}><li className="capitalize hover:bg-green-500 cursor-pointer rounded-md p-2">consulting</li></Link>
                                                <Link to={"/other-services"}><li className="capitalize hover:bg-green-500 cursor-pointer rounded-md p-2">training</li></Link>
                                                <Link to={"/other-services"}><li className="capitalize hover:bg-green-500 cursor-pointer rounded-md p-2">maintenance and support</li></Link>
                                            </ul>
                                        </div> */}
                                    </div>
                                </ul>
                            </div>
                        </li>
                        {/* <li className='capitalize text-sm font-light tracking-tight hover:text-green-500'><Link to={'/case-studies'}>case studies</Link></li> */}
                        {/* <li className='capitalize text-sm font-light tracking-tight hover:text-green-500'><Link to={'/blogs'}>blogs</Link></li> */}
                        {/* <li className='relative capitalize text-sm font-light tracking-tight hover:text-green-700 after:content-[""] after:absolute after:left-1/2 after:-translate-x-1/2 after:bottom-[-5px] after:h-[2px] after:w-0 after:bg-green-600 after:transition-all after:duration-300 hover:after:w-full'><a href={'/rentals'}>rentals</a></li> */}
                        {/* <li className='relative capitalize text-sm font-light tracking-tight hover:text-green-700 after:content-[""] after:absolute after:left-1/2 after:-translate-x-1/2 after:bottom-[-5px] after:h-[2px] after:w-0 after:bg-green-600 after:transition-all after:duration-300 hover:after:w-full'><a href='/travel-guides' rel='norefferer'>Travel Guides</a></li>
                        <li className='relative capitalize text-sm font-light tracking-tight hover:text-green-700 after:content-[""] after:absolute after:left-1/2 after:-translate-x-1/2 after:bottom-[-5px] after:h-[2px] after:w-0 after:bg-green-600 after:transition-all after:duration-300 hover:after:w-full'><a href='/booking' rel='norefferer'>Booking </a></li> */}
                        <li className='relative capitalize text-sm font-light tracking-tight hover:text-green-700 after:content-[""] after:absolute after:left-1/2 after:-translate-x-1/2 after:bottom-[-5px] after:h-[2px] after:w-0 after:bg-green-600 after:transition-all after:duration-300 hover:after:w-full'><a href='/about-us' rel='norefferer'>About</a></li>
                        <li className='relative capitalize text-sm font-light tracking-tight hover:text-green-700 after:content-[""] after:absolute after:left-1/2 after:-translate-x-1/2 after:bottom-[-5px] after:h-[2px] after:w-0 after:bg-green-600 after:transition-all after:duration-300 hover:after:w-full'><a href='/digital-space' rel='norefferer'>Digital Space</a></li>
                        <li className='relative capitalize text-sm font-light tracking-tight hover:text-green-700 after:content-[""] after:absolute after:left-1/2 after:-translate-x-1/2 after:bottom-[-5px] after:h-[2px] after:w-0 after:bg-green-600 after:transition-all after:duration-300 hover:after:w-full'><a href='/contact-us' rel='norefferer'>contact</a></li>
                    </ul>
                </div>
                {/* Desktop "our virtual tours" button - hidden on mobile */}
                <div className='hidden md:block'>
                    <a href='/virtual-tour' rel='norefferer'>
                        <button className='capitalize px-6 py-2 text-sm border-x border-y bg-green-600/80 text-black border-none rounded-sm hover:bg-green-600 hover:border-green-600 hover:text-white transition-all duration-300'>
                            virtual tours
                        </button>
                    </a>
                </div>
            </div>

            {/* Mobile Menu Overlay - overlaps all content in mobile view */}
            {isMenuOpen && (
                <div className="fixed inset-0 bg-green-700 z-[60] md:hidden flex flex-col items-center justify-center text-center">
                    <button onClick={toggleMenu} className='absolute top-4 right-4 text-white text-3xl focus:outline-none'>
                        <HiX />
                    </button>
                    <div className='flex flex-col gap-7 text-white text-2xl w-full px-4'>
                        <ul className='flex flex-col gap-3 justify-center text-center text-sm items-center'>
                            {/* <li className='capitalize text-lg font-light tracking-tight py-2 hover:text-green-600'><a href={'/'} onClick={toggleMenu}>Home</a></li> */}
                            <li className='relative capitalize text-base font-light tracking-tight py-2 hover:text-gray-300'>
                                <button onClick={toggleShopDropdown} className='flex items-center gap-1 cursor-pointer text-white hover:text-green-600 focus:outline-none'>
                                    <span className='capitalize text-lg'>Experience Africa</span>
                                    <IoIosArrowDown className={`${shopDropdown ? 'rotate-180' : ''} transition-transform duration-200`} />
                                </button>
                                {shopDropdown && (
                                    <ul className='flex flex-col gap-2 mt-2 text-sm text-white items-center'>
                                        <li className='p-1 capitalize hover:text-green-600'><a href={'/cultural-festivals'} onClick={toggleMenu}>Cultural Festivals</a></li>
                                        <li className='p-1 capitalize hover:text-green-600'><a href={'/historical-tours'} onClick={toggleMenu}>Historical Tours</a></li>
                                        <li className='p-1 capitalize hover:text-green-600'><a href={'/wildlife-safaris'} onClick={toggleMenu}>Wildlife Safaris</a></li>
                                    </ul>
                                )}
                            </li>
                            {/* <li className='capitalize text-lg font-light tracking-tight py-2 hover:text-green-600'><a href={'/case-studies'} onClick={toggleMenu}>case studies</a></li> */}
                            {/* <li className='capitalize text-lg font-light tracking-tight py-2 hover:text-green-600'><a href={'/blogs'} onClick={toggleMenu}>blogs</a></li> */}
                            {/* <li className='capitalize text-lg font-light tracking-tight py-2 hover:text-green-600'><a href={'/rentals'} onClick={toggleMenu}>rentals</a></li> */}
                            {/* <li className='capitalize text-lg font-light tracking-tight py-2 hover:text-green-600'><a href={'/travel-guides'} onClick={toggleMenu}>Travel Guides</a></li>
                            <li className='capitalize text-lg font-light tracking-tight py-2 hover:text-green-600'><a href={'/booking'} onClick={toggleMenu}>Booking </a></li> */}
                            <li className='capitalize text-lg font-light tracking-tight py-2 hover:text-green-600'><a href={'/about-us'} onClick={toggleMenu}>About</a></li>
                            <li className='capitalize text-lg font-light tracking-tight py-2 hover:text-green-600'><a href={'/digital-space'} onClick={toggleMenu}>Digital Space</a></li>
                            <li className='capitalize text-lg font-light tracking-tight py-2 hover:text-green-600'><a href={'/contact-us'} onClick={toggleMenu}>contact</a></li>
                            <li className='capitalize text-sm font-light tracking-tight hover:text-green-600'>
                                <a href='/virtual-tour' onClick={toggleMenu}>
                                    <button className='capitalize px-10 py-2 text-white border-x border-y bg-none border-white rounded-sm hover:text-black hover:border-white transition-all duration-300'>
                                        virtual tours
                                    </button>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            )}
        </div>
    );
};

export default PageHeader;
